import { render, staticRenderFns } from "./WorkRecords.vue?vue&type=template&id=89f79d5a&scoped=true"
import script from "./WorkRecords.vue?vue&type=script&lang=js"
export * from "./WorkRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f79d5a",
  null
  
)

export default component.exports